// Mentions
// --------------------------------------------------------
import api from '@/lib/api'
import {MentionTypes, MentionActions} from '@/lib/definitions'

const state = {
  mentions: []
}

const getters = {
  mentions: state => state.mentions,
  unreadMentions: state => state.mentions.some(mentions => !mentions.read)
}

const mutations = {
  updateMentions(state, mentions) {
    mentions.forEach(mention => {
      // update dupes
      const index = state.mentions.findIndex(m => m.key === mention.key)
      if (index > -1) {
        state.mentions.splice(index, 1, mention)
      } else {
        state.mentions.push(mention)
      }
    })
    // sort
    state.mentions = state.mentions.sort((a, b) => {
      if (a.updatedAt < b.updatedAt) return 1
      if (a.updatedAt > b.updatedAt) return -1
      return 0
    })
  },
  setMentions(state, mentions) {
    state.mentions = mentions || []
  },
  readMention(state, mention) {
    if (mention) mention.read = true
  },
  dismissMention(state, mention) {
    if (mention) {
      const index = state.mentions.findIndex(m => m.key === mention.key)
      state.mentions.splice(index, 1)
    }
  },
  readAllMentions(state) {
    state.mentions.forEach(mention => (mention.read = true))
  },
  dismissAllMentions(state) {
    state.mentions = []
  },
  unreadAllMentions(state) {
    state.mentions.forEach(mention => (mention.read = false))
  }
}

const actions = {
  updateMentions: ({commit}, mentions) => {
    // in case of invitation accepted, add user to landscape user list
    mentions.forEach(mention => {
      if (
        mention.action === MentionActions.INVITATION &&
        mention.type === MentionTypes.ACCEPTED
      ) {
        if (mention.excerpt && mention.excerpt[0] === '{')
          commit('injectUser', JSON.parse(mention.excerpt)) // TODO: JSON.parse ?
      }
    })
    commit('updateMentions', mentions)
  },
  dismissMention: ({getters, commit}, payload) => {
    const landscapeId = getters.currentLandscape._id
    return api
      .call('put', `landscapes/${landscapeId}/mentions/${payload.key}`, {
        dismissed: true
      })
      .then(() => {
        const mention = getters.mentions.find(m => m.key === payload.key)
        if (!mention.read) {
          commit('updateMentionCount', {landscapeId, diff: -1})
        }
        commit('dismissMention', mention)
      })
  },
  dismissAllMentions: ({getters, commit}) => {
    const landscapeId = getters.currentLandscape._id
    return api
      .call('put', `landscapes/${landscapeId}/mentions`, {dismissed: true})
      .then(() => {
        commit('dismissAllMentions')
        commit('updateMentionCount', {landscapeId, set: 0})
      })
  },
  readAllMentions: ({getters, commit}) => {
    const landscapeId = getters.currentLandscape._id
    return api
      .call('put', `landscapes/${landscapeId}/mentions`, {read: true})
      .then(() => {
        commit('readAllMentions')
        commit('updateMentionCount', {landscapeId, set: 0})
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
